import { DialogContent } from '@mui/material'
import { t } from 'i18next'

import CustomDialog from '@/components/feedback/CustomDialog'
import { ServiceRuleDetailsForm } from '@/features/site/components/availability/serviceRule/form/ServiceRuleDetailsForm'
import type { MarketProgram } from '@/features/site/types/marketProgram'

interface RestrictionDetailsCreateDialogProps {
  open: boolean
  onClose: () => void
  marketProgram: MarketProgram
  customerTimeZone: string
  customerLocation: string
  customerUuid: string
}

export const ServiceRuleDetailsCreateDialog = (props: RestrictionDetailsCreateDialogProps) => {
  return (
    <CustomDialog
      open={props.open}
      size="large"
      title={t('customer_details.tabs.availability.availability_details.dialog.title.create')}
      onClose={props.onClose}
    >
      <DialogContent>
        <ServiceRuleDetailsForm
          marketProgram={props.marketProgram}
          siteLocation={props.customerLocation}
          siteTimezone={props.customerTimeZone}
          siteUuid={props.customerUuid}
          onClose={props.onClose}
        />
      </DialogContent>
    </CustomDialog>
  )
}
